import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import productReducer from './slices/productSlice';
import cartReducer from './slices/cartSlice';
import orderReducer from './slices/orderSlice';
import uiReducer from './slices/uiSlice';
import sellerReducer from './sellerSlice';
import adminReducer from './adminSlice';
import customerReducer from './customerSlice';
import visitRequestReducer from './slices/visitRequestSlice';
import analyticsReducer from './slices/analyticsSlice';
import reviewReducer from './slices/reviewSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    products: productReducer,
    cart: cartReducer,
    orders: orderReducer,
    ui: uiReducer,
    seller: sellerReducer,
    admin: adminReducer,
    customer: customerReducer,
    visitRequests: visitRequestReducer,
    analytics: analyticsReducer,
    reviews: reviewReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export { store };
export default store;